import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './layouts/main/layout.component';
import { AuthComponent } from './layouts/auth/auth.component';
import { extraPagesComponent } from './layouts/extra-pages/extra-pages.component';
import { PaymentGatewayCallbackComponent } from './resources/account/auth/payment-gateway-callback/payment-gateway-callback.component';

export const routes: Routes = [
    {
        path: "auth",
        component: AuthComponent,
        loadChildren: () =>
            import("./resources/account/account.module").then((m) => m.AccountModule),
    },
    {   
        path: 'payment-gateway', 
        component: PaymentGatewayCallbackComponent, 
        data: { title: 'PAGE_TITLES.payment-gateway-callback' } 
    },
    {
        path: "",
        component: LayoutComponent,
        loadChildren: () =>
            import("./resources/pages/pages.module").then((m) => m.PagesModule),
        canActivate: [AuthGuard],
    },
    {
        path: "pages",
        loadChildren: () =>
            import("./resources/extrapages/extrapages.module").then((m) => m.ExtrapagesModule),
        canActivate: [AuthGuard],
    },
    {   
        path: "**", 
        component: extraPagesComponent, 
        loadChildren: () =>
            import("./resources/extrapages/extrapages.module").then((m) => m.ExtrapagesModule),
    }
];
